import api from '../../services/api';
import {
  GET_CUSTOMER_ORDERS_REQUEST,
  GET_CUSTOMER_ORDERS_SUCCESS,
  GET_CUSTOMER_ORDERS_FAILURE,
  GET_CUSTOMER_ORDER_REQUEST,
  GET_CUSTOMER_ORDER_SUCCESS,
  GET_CUSTOMER_ORDER_FAILURE,
  CREATE_CUSTOMER_ORDER_REQUEST,
  CREATE_CUSTOMER_ORDER_SUCCESS,
  CREATE_CUSTOMER_ORDER_FAILURE,
  UPDATE_CUSTOMER_ORDER_REQUEST,
  UPDATE_CUSTOMER_ORDER_SUCCESS,
  UPDATE_CUSTOMER_ORDER_FAILURE,
  ASSIGN_GOLDSMITH_REQUEST,
  ASSIGN_GOLDSMITH_SUCCESS,
  ASSIGN_GOLDSMITH_FAILURE,
  ADD_ORDER_PAYMENT_REQUEST,
  ADD_ORDER_PAYMENT_SUCCESS,
  ADD_ORDER_PAYMENT_FAILURE,
  GET_ORDER_PAYMENTS_REQUEST,
  GET_ORDER_PAYMENTS_SUCCESS,
  GET_ORDER_PAYMENTS_FAILURE,
} from '../types';

// Get customer orders
export const getCustomerOrders = (filters = {}) => async (dispatch) => {
  try {
    dispatch({ type: GET_CUSTOMER_ORDERS_REQUEST });
    
    const queryParams = new URLSearchParams();
    if (filters.status) queryParams.append('status', filters.status);
    if (filters.customerId) queryParams.append('customer_id', filters.customerId);
    if (filters.goldsmithId) queryParams.append('goldsmith_id', filters.goldsmithId);
    if (filters.startDate) queryParams.append('start_date', filters.startDate);
    if (filters.endDate) queryParams.append('end_date', filters.endDate);
    if (filters.page) queryParams.append('page', filters.page);
    if (filters.limit) queryParams.append('limit', filters.limit);
    
    const response = await api.get(`/customer-orders?${queryParams.toString()}`);
    
    dispatch({
      type: GET_CUSTOMER_ORDERS_SUCCESS,
      payload: response.data,
    });
    
    return { success: true, data: response.data };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to fetch customer orders';
    dispatch({
      type: GET_CUSTOMER_ORDERS_FAILURE,
      payload: message,
    });
    return { success: false, message };
  }
};

// Get single customer order
export const getCustomerOrder = (orderId) => async (dispatch) => {
  try {
    dispatch({ type: GET_CUSTOMER_ORDER_REQUEST });
    
    const response = await api.get(`/customer-orders/${orderId}`);
    
    dispatch({
      type: GET_CUSTOMER_ORDER_SUCCESS,
      payload: response.data,
    });
    
    return { success: true, data: response.data };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to fetch customer order';
    dispatch({
      type: GET_CUSTOMER_ORDER_FAILURE,
      payload: message,
    });
    return { success: false, message };
  }
};

// Create customer order
export const createCustomerOrder = (orderData) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_CUSTOMER_ORDER_REQUEST });
    
    const response = await api.post('/customer-orders', orderData);
    
    dispatch({
      type: CREATE_CUSTOMER_ORDER_SUCCESS,
      payload: response.data,
    });
    
    return { success: true, data: response.data };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to create customer order';
    dispatch({
      type: CREATE_CUSTOMER_ORDER_FAILURE,
      payload: message,
    });
    return { success: false, message };
  }
};

// Update customer order
export const updateCustomerOrder = (orderId, orderData) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_CUSTOMER_ORDER_REQUEST });
    
    const response = await api.put(`/customer-orders/${orderId}`, orderData);
    
    dispatch({
      type: UPDATE_CUSTOMER_ORDER_SUCCESS,
      payload: response.data,
    });
    
    return { success: true, data: response.data };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to update customer order';
    dispatch({
      type: UPDATE_CUSTOMER_ORDER_FAILURE,
      payload: message,
    });
    return { success: false, message };
  }
};

// Assign goldsmith to order
export const assignGoldsmithToOrder = (orderId, goldsmithId) => async (dispatch) => {
  try {
    dispatch({ type: ASSIGN_GOLDSMITH_REQUEST });
    
    const response = await api.post(`/customer-orders/${orderId}/assign-goldsmith`, {
      goldsmith_id: goldsmithId,
    });
    
    dispatch({
      type: ASSIGN_GOLDSMITH_SUCCESS,
      payload: response.data,
    });
    
    return { success: true, data: response.data };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to assign goldsmith';
    dispatch({
      type: ASSIGN_GOLDSMITH_FAILURE,
      payload: message,
    });
    return { success: false, message };
  }
};

// Add order payment
export const addOrderPayment = (orderId, paymentData) => async (dispatch) => {
  try {
    dispatch({ type: ADD_ORDER_PAYMENT_REQUEST });
    
    const response = await api.post(`/customer-orders/${orderId}/payment`, paymentData);
    
    dispatch({
      type: ADD_ORDER_PAYMENT_SUCCESS,
      payload: response.data,
    });
    
    return { success: true, data: response.data };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to add payment';
    dispatch({
      type: ADD_ORDER_PAYMENT_FAILURE,
      payload: message,
    });
    return { success: false, message };
  }
};

// Get order payments by payment mode
export const getOrderPayments = (filters = {}) => async (dispatch) => {
  try {
    dispatch({ type: GET_ORDER_PAYMENTS_REQUEST });
    
    const queryParams = new URLSearchParams();
    if (filters.paymentModeId) queryParams.append('paymentModeId', filters.paymentModeId);
    if (filters.startDate) queryParams.append('startDate', filters.startDate);
    if (filters.endDate) queryParams.append('endDate', filters.endDate);
    if (filters.page) queryParams.append('page', filters.page);
    if (filters.limit) queryParams.append('limit', filters.limit);
    
    const response = await api.get(`/customer-orders/payments/list?${queryParams.toString()}`);
    
    dispatch({
      type: GET_ORDER_PAYMENTS_SUCCESS,
      payload: response.data,
    });
    
    return { success: true, data: response.data };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to fetch order payments';
    dispatch({
      type: GET_ORDER_PAYMENTS_FAILURE,
      payload: message,
    });
    return { success: false, message };
  }
};
